import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function Inbox({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Inbox'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

